import { styled } from '@mui/system'
import { Box, Box as MuiBox } from '@mui/material'

export const FilterIconBox = styled(MuiBox)(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  width: '40px',
  height: '32px',
  color: theme.palette.grey['800'],
  gap: theme.spacing(1),
  border: 'px solid #DAE0E7',
  clipPath: 'polygon(0% 0%, 75% 0%, 100% 50%, 75% 100%, 0% 100%)',
  backgroundColor: '#DAE0E7',
  borderRadius: '4px',
}))

export const FilterIconBoxBleed = styled(Box)`
  display: flex;
  align-items: center;
  height: 30px;
  width: 38px;
  padding-left: 9px;
  margin: 0 0 0 1px;
  clip-path: polygon(0% 0%, 75% 0%, 100% 50%, 75% 100%, 0% 100%);
  background-color: white;
  border-radius: 4px;
`

export const FilterBox = styled(MuiBox)(({ theme }) => ({
  whiteSpace: 'nowrap',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.spacing(1),
  border: '1px solid #DAE0E7',
  fontSize: '13px',
  borderRadius: '4px',
  color: theme.palette.grey['800'],
  padding: '0 16px',
  cursor: 'pointer',
  fontWeight: '400',
  height: '32px',
  transition: 'all ease-in-out .2s',
  ':hover': {
    backgroundColor: '#F2F3F8',
    border: '1px solid #F2F3F8',
  },
}))

export const FilterBoxChecked = styled(FilterBox)(() => ({
  whiteSpace: 'nowrap',
  backgroundColor: '#F2F3F8',
  color: '#45525E',
  fontWeight: '600',
}))

export const FilterCount = styled(FilterBox)(({ theme }) => ({
  backgroundColor: '#F2F3F8',
  color: theme.palette.grey['800'],
  fontWeight: '400',
  padding: '0 4px',
  height: '20px',
}))

export const FilterCountChecked = styled(FilterBox)(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  color: theme.palette.grey['800'],
  fontWeight: '400',
  padding: '0 4px',
  height: '20px',
  ':hover': {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.grey['800'],
  },
}))

export const FiltersContainer = styled(MuiBox)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.spacing(3),
  lineHeight: 1.5,
  fontSize: 14,
  textAlign: 'center',
}))

export const CtrlViewButton = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #dae0e7;
  width: 40px;
  color: #677c8e;
  height: 32px;
  font-size: 16px;
  &:hover {
    cursor: pointer;
  }
  &.is-active {
    font-weight: 600;
    background: white;
    color: #146bb8;
    cursor: not-allowed;
  }
`

export const GroupCtrlViewButton = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  border: 1px solid #dae0e7;
  border-radius: 4px;
  gap: 1px;
  transition: 0.2;
  overflow: hidden;
  background-color: #dae0e7;
  //
  //&:hover {
  //  background: #dae0e7;
  //}
  //
`

export const ContentFilters = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
  gap: '16px',
}))

export default ContentFilters
